export default "__VITE_ASSET__BMe1JKCD__"